import { compose } from 'redux'

// HOC with logic shared by account manager
import { withRegistrationPaymentForm } from 'components/account/Billing/Payment/Form'

// presentational component specific to registration flow
import UI from './UI'

export default compose(withRegistrationPaymentForm)(UI)
